export default "__VITE_ASSET__2a1b4a8e__"